import { render, staticRenderFns } from "./SectorDetail.vue?vue&type=template&id=eda22f0c"
import script from "./SectorDetail.vue?vue&type=script&lang=js"
export * from "./SectorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports